export default __webpack_public_path__ + "static/media/journald_monitor.7a62fa30.md";